import { GetServiceStatisticType, OrderStatisticsService } from '@/backend/market'
import type { StatisticSummaryFilterEntity } from '../../domain/entities/StatisticSummaryFilterEntity'
import { DashboardRepository } from '../../domain/repositories/DashboardRepository'
import { StatisticSummaryFilterModel } from '../models/StatisticSummaryFilterModel'
import type { ServiceStatisticSummaryResponseEntity } from '../../domain/entities/ServiceStatisticSummaryResponseEntity'
import { ServiceStatisticSummaryResponseModel } from '../models/ServiceStatisticSummaryResponseModel'
import type { StatisticFilterEntity } from '../../domain/entities/StatisticFilterEntity'
import { StatisticFilterModel } from '../models/StatisticFilterModel'
import { ServiceStatisticMiniModel } from '../models/ServiceStatisticMiniModel'
import type { ServiceStatisticMiniEntity } from '../../domain/entities/ServiceStatisticMiniEntity'

export class DashboardRepositoryImpl implements DashboardRepository {
  async getServiceStatisticsRequest(
    filterData: StatisticFilterEntity
  ): Promise<ServiceStatisticMiniEntity[] | { error: true }> {
    const serviceStatisticFilterData = new StatisticFilterModel(filterData)
    try {
      const response = await OrderStatisticsService.getServiceStatisticsAdmin(
        serviceStatisticFilterData as unknown as {
          startDate: string
          endDate: string
          type: GetServiceStatisticType
          serviceId?: number
          regionId?: number
          branchId?: number
        }
      )
      const responseModels = response.orderStatistics?.map(
        (item) => new ServiceStatisticMiniModel(item, filterData.type)
      )
      return responseModels ?? []
    } catch (error) {
      return { error: true }
    }
  }

  async getServiceStatisticsSummeryRequest(
    filterData: StatisticSummaryFilterEntity
  ): Promise<ServiceStatisticSummaryResponseEntity | { error: true }> {
    const summeryFilterData = new StatisticSummaryFilterModel(filterData)
    try {
      const response =
        await OrderStatisticsService.getServiceStatisticSummeryAdmin(summeryFilterData)
      const responseModel = new ServiceStatisticSummaryResponseModel(response)
      return responseModel
    } catch (error) {
      return { error: true }
    }
  }
}
